document.addEventListener("DOMContentLoaded", function () {

  function initAddCompleteLook() {
    const btn = document.getElementById('add-complete-look');

    if (!btn) return;

    btn.addEventListener('click', function () {

      function openCartDrawer() {
        document.dispatchEvent(new CustomEvent('cart:open'));

        setTimeout(() => {
          const cartIcon = document.querySelector(
            'a[href="/cart"], button[name="cart"], .header__icon--cart'
          );
          if (cartIcon) {
            cartIcon.click();
          }
        }, 100);
      }

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {

          let itemsToAdd = [];

          document.querySelectorAll('[data-variant-id]').forEach(item => {
            let id = parseInt(item.dataset.variantId);

            if (!id) return; 

            let exists = cart.items.find(p => p.variant_id === id);

            if (!exists) {
              itemsToAdd.push({
                id: id,
                quantity: 1
              });
            }
          });

          if (itemsToAdd.length === 0) {
            openCartDrawer();
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          })
          .then(() => {
            openCartDrawer();
          })
          .catch(err => {
            console.error('Add to cart error:', err);
          });

        })
        .catch(err => {
          console.error('Cart fetch error:', err);
        });

    });
  }
  initAddCompleteLook();

  document.addEventListener('shopify:section:load', initAddCompleteLook);

});

document.addEventListener("DOMContentLoaded", function () {
  const scrollBtn = document.querySelector("#scroll-down-btn");

  if (scrollBtn) {
    scrollBtn.addEventListener("click", function () {

      const targetSection = document.querySelector("#LogoLits");
      const header = document.querySelector('.section-header');
      const offset = header ? header.offsetHeight : 0;

      if (targetSection) {
        const elementPosition = targetSection.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }

    });
  }
});


(function () {

  let observer;

  function createObserver() {
    if (observer) return;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: "0px 0px -50px 0px" 
    });
  }

  function initAnimation(scope = document) {
    createObserver();

    const elements = scope.querySelectorAll(".anim:not(.observed)");

    elements.forEach((el) => {
      observer.observe(el);
      el.classList.add("observed");
    });
  }
  document.addEventListener("DOMContentLoaded", () => {
    initAnimation(document);
  });

  window.addEventListener("load", () => {
    initAnimation(document);
  });

  document.addEventListener("shopify:section:load", (e) => {
    initAnimation(e.target);
  });

  document.addEventListener("shopify:section:reorder", (e) => {
    initAnimation(document);
  });

  document.addEventListener("shopify:block:select", (e) => {
    initAnimation(e.target);
  });

  const mutationObserver = new MutationObserver(() => {
    initAnimation(document);
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
